import { baseApi } from "./baseApi";
import HeaderService from "../../services/headerService";

const headerService = new HeaderService();

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfile: builder.query({
      query: () => ({
        url: `/userprofile`,
        headers: headerService.getAuthorizationHeader(),
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data: userProfileResponse } = await queryFulfilled;
          const data = userProfileResponse
            ? JSON.parse(JSON.stringify(userProfileResponse))
            : {};
          return data;
        } catch (e) {
          console.log("execption", e);
        }
      },
    }),
  }),
});

export const { useGetUserProfileQuery, useLazyGetUserProfileQuery } = userApi;
